import { combineReducers } from 'redux'
import auth from './auth'
import appUser from './appUser'
import material from './material'
import barcodeProduct from './barcodeProduct'
import hero from './hero'
import heroLink from './heroLink'
import heroNews from './heroNews'
import news from './news'
import banners from './banners'
import coin from './coin'
import brand from './brand'
import user from './user'
import productFeature from './productFeature'
import document from './document'
import reports from './reports'
import bin from './bin'
import brandActivity from './brandActivity'
import brandNews from './brandNews'
import brandCover from './brandCover'
import location from './location'
import userAnnouncement from './userAnnouncement'
import heroPromote from './heroPromote'
import reward from './reward'
import equipment from './equipment'
import preset from './preset'
import step from './step'
import appVersion from './appVersion'
import reportProblem from './reportProblem'
import notification from './notification'

export default combineReducers({
  auth,
  appVersion,
  appUser,
  brand,
  brandActivity,
  brandNews,
  brandCover,
  bin,
  material,
  heroPromote,
  barcodeProduct,
  reports,
  hero,
  heroNews,
  heroLink,
  reward,
  equipment,
  preset,
  step,
  news,
  banners,
  document,
  coin,
  user,
  productFeature,
  location,
  userAnnouncement,
  reportProblem,
  notification
})



// WEBPACK FOOTER //
// ./src/modules/index.js